// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1rOkQ","buttons":"Footer_buttons__A51zb"};